export const environment = {
  preproduction: true,
    production: false,
  api: {
    BASE_URL: 'https://preprod-api.collary.fr/api/api',
    BASE_URL_NOTIF: 'https://preprod-api.collary.fr/api',
    AUTH_URL: 'https://preprod-api.collary.fr/api/auth',
    OPEN_STREET_URL: 'https://nominatim.openstreetmap.org/search?format=json',
    COMMUNES_URL: 'https://geo.api.gouv.fr/communes',
    REGIONS_URL: 'https://geo.api.gouv.fr/regions',
    DEPARTMENTS_URL: 'https://geo.api.gouv.fr/departements',
    URL: 'https://preprod-team.collary.fr',
  },
  BASE_64: 'data:image/jpeg;base64,',
  AUTHORIZATION: 'Bearer eyJhY2Nlc3MtdG9rZW4iOiJVZVdkdm81ZEdDSXdCdjVLWDUweVdBIiwidG9rZW4tdHlwZSI6IkJlYXJlciIsImNsaWVudCI6ImRraHZiZUNyS1ZnOHNpS2pFRVF3blEiLCJleHBpcnkiOiIxNzIyNTYxMzQzIiwidWlkIjoiYWxhYUBnbWFpbC5jb20ifQ==',
  appName: 'Collary Team - preprod',
  version: '1.0.0-preprod'
};